import TenByTwentyRelated from "assets/images/psp/relatedContentImages/10x20-storage-guide.webp";
import CarStorageRelated from "assets/images/psp/relatedContentImages/car-storage.webp";
import TruckTrailerRelated from "assets/images/psp/relatedContentImages/truck-trailer-storage.webp";
import FacilitiesRelated from "assets/images/psp/relatedContentImages/do-facilities-offer-moving-trucks.webp";
import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import HeaderBackgroundDesktop from "assets/images/psp/hero/truck-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/truck-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/truck-header-tablet.webp";
import { storageCategories } from "../utils/getPSPLinks";

const reviews = {
	title: "Storage.com has 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "My Storage.com representative was very helpful and patient with me, working through to find the best location and price.",
			author: "Jess",
			title: "Very helpful",
			imageSrc: GeorgeRansom
		},
		{
			body: "Storage.com did an excellent job helping me find a storage facility at a great price. Better than the price that I found.",
			author: "Alison",
			title: "Storage facility",
			imageSrc: AnnAlarcon
		},
		{
			body: "Storage.com found me a spot immediately for half the price I had found in my search. Very courteous representatives.",
			author: "Robert Fulton",
			title: "Excellent!",
			imageSrc: SMurphy
		}
	]
};

const faqs = [
	{
		question:
			"What size storage unit do I need for a full-size pickup truck?",
		answer: "Most full-size pickups (F-150, Silverado, Ram 1500) fit comfortably in 10x20 or 10x25 units. Lifted trucks or those with extended cabs may require 10x30 units."
	},
	{
		question: "Can I store a truck with a camper attached?",
		answer: "Yes, many facilities offer 12x30 or 12x40 units specifically designed for truck camper storage. Outdoor parking spaces also accommodate trucks with campers attached."
	},
	{
		question: "Is outdoor truck storage safe?",
		answer: "Outdoor storage at reputable facilities provides excellent security with gated access, surveillance cameras, and regular patrols. It's significantly safer than street parking and more affordable than enclosed options."
	},
	{
		question: "How much does cheap truck storage cost per month?",
		answer: "Basic outdoor parking for pickup truck storage starts around $50-$75 monthly in most markets, while enclosed drive-up units range $100-$200 depending on size and location."
	},
	{
		question: "Can I access my truck storage unit anytime?",
		answer: "Most facilities offer daily access during gate hours (typically 6am-9pm), with some premium locations providing 24/7 access. Unlike long-term vehicle storage programs, you maintain complete access control."
	},
	{
		question: "Do I need insurance for my truck in storage?",
		answer: "While facilities carry property insurance, they don't cover stored vehicles. Your auto insurance typically extends to storage situations, but verify coverage with your provider."
	},
	{
		question: "What's the difference between truck storage and RV storage?",
		answer: "Truck storage spaces are typically smaller (10x20-10x30) and more affordable than RV storage. However, larger enclosed RV units can accommodate trucks with campers or trailers attached."
	},
	{
		question: "Can I get a free moving truck with my storage rental?",
		answer: 'Yes, many facilities on Storage.com offer storage with free truck rental as an amenity. Use our "Free Truck Rental" filter to find locations that provide this benefit, making it easier to move your belongings without paying for separate truck rental services.'
	}
];

const relatedContentCards = [
	{
		content:
			"Do Storage Facilities Offer Moving Truck Rentals? How to Get a Free Moving Truck with Your Storage Rental",
		category: "Moving Advice",
		date: "December 26, 2025",
		url: "https://www.storage.com/blog/do-self-storage-facilities-offer-moving-truck-rentals/",
		image: FacilitiesRelated
	},
	{
		content:
			"Truck and Trailer Storage Guide 2025: Costs, Options, and Tips for Every Vehicle",
		category: "Self-Storage",
		date: "July 30, 2025",
		url: "https://www.storage.com/blog/truck-trailer-storage-guide/",
		image: TruckTrailerRelated
	},
	{
		content: "Vehicle Storage: Where and How To Store a Car",
		category: "Self-Storage",
		date: "July 30, 2025",
		url: "https://www.storage.com/blog/the-complete-guide-to-vehicle-storage/",
		image: CarStorageRelated
	},
	{
		content: "The Ultimate 10×20 Storage Unit Size Guide",
		category: "Self-Storage",
		date: "October 15, 2025",
		url: "https://www.storage.com/blog/10x20-storage-unit-size-guide/",
		image: TenByTwentyRelated
	}
];

const truckHerodescription = `
From moving homes to downsizing and decluttering, renting a storage unit is often just one part of a bigger transition. That's why many storage facilities with free truck rental programs now offer complimentary moving trucks with your storage unit. When you choose storage units with free truck access, [you're not just renting space—you're getting a complete moving solution.](https://www.storage.com/blog/self-storage-unit-size-guide-2/) These all-in-one packages eliminate the hassle of coordinating separate truck rentals and storage arrangements, letting you focus on what matters most during your transition.
`;

export const PSPTruckContent = {
	type: "Storage Units with Free Truck Rentals",
	sections: [
		// ── 1. Hero Section ─────────────────────────
		{
			title: "Storage with Truck Rental hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find Free Moving Truck with Your Storage Rental",
						description: truckHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Storage with Truck Rental",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Storage with Truck Rental Hero Image"
					}
				}
			]
		},

		// ── 2. Content Section 1 ────────────────────
		{
			title: "Looking for Storage with Free Truck Rentals?",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Looking for Storage with Free Truck Rentals?",
						content: [
							{
								id: "1",
								value: "Whether you're looking for pickup truck storage because of an upcoming move or are looking to clear some extra space in your home, you can find exactly what you need with Storage.com."
							},
							{
								id: "2",
								value: "Moving your belongings into storage doesn't have to mean renting a truck separately. Many facilities in our network offer self-storage and truck rental combined into one convenient package. When you're [storing your oven or large appliances](https://www.storage.com/blog/how-to-move-and-store-a-stove/), or just need extra space for gear and equipment, finding storage units with free truck rentals can save you time and money on moving day."
							},
							{
								id: "3",
								value:
									"Here's how to find facilities offering a free moving truck with storage rental:\n\n" +
									"1. Visit Storage.com and enter your zip code or the area where you need storage\n" +
									"2. Look for the **Filter Results** menu on the left side of the page\n" +
									"3. You'll see filter sections for both unit sizes and amenities\n" +
									'4. Under **Amenities Filters**, check the box for **"Free Truck Rental"**\n' +
									"5. Browse facilities offering this benefit in your area\n" +
									"6. Reserve your unit online through Storage.com\n" +
									"7. Always call the facility after reserving to confirm truck availability on your desired moving date and time"
							},
							{
								id: "4",
								value: "This amenity is especially valuable when you're moving items out of your truck bed or garage to make room for your vehicle, or when you need to transport tools and equipment to your storage space. The combination of storage with free truck rental simplifies the entire process, letting you handle your move and storage setup in one trip."
							}
						],
						isColumnWise: false,
						background: "light-blue"
					}
				}
			]
		},

		// ── 3. Content Section 2 ────────────────────
		{
			title: "Key Benefits of Free Truck Rental",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Key Benefits of Getting a Free Truck with Your Storage Rental:",
						background: "white",
						content: [
							{
								id: "1",
								value:
									"- **Significant Cost Savings:** Moving truck rentals typically cost $50-$150 per day, plus mileage fees. Getting one free with your storage units with truck rental puts that money back in your pocket, reducing your overall moving expenses considerably.\n\n" +
									"- **Streamlined Moving Process:** Coordinate your move and storage in one trip. Load your belongings once, drive directly to your storage facility, and unload, eliminating the need for multiple vehicles or rental arrangements.\n\n" +
									"- **Flexibility and Convenience:** Many facilities offering storage with free truck access provide flexible booking windows, allowing you to schedule your move around your availability rather than working around limited rental company hours.\n\n" +
									"- **No Hidden Fees or Mileage Charges:** Unlike traditional truck rental companies that charge per mile, storage facilities with free truck rental programs often come with generous mileage allowances or unlimited local use, helping you avoid unexpected costs.\n\n" +
									"- **Right-Sized Vehicle Options:** Storage facilities typically offer a range of truck sizes to suit your needs, from cargo vans for small loads to large box trucks for complete household moves.\n\n" +
									"- **Professional Support:** Benefit from staff who understand both moving and storage, providing helpful advice on packing, loading techniques, and maximizing your storage space."
							}
						],
						isColumnWise: false
					}
				}
			]
		},

		// ── 4. Size Comparison ───────────────────────
		{
			title: "Truck Storage Unit Sizes",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						pageType: "psp",
						title: "Who Benefits Most from Free Moving Truck Offers?",
						description: "",
						sizes: [
							{
								id: "families",
								label: "Moving Families",
								title: "Moving Families",
								description:
									"- Transport furniture, boxes, and belongings\n" +
									"- Use a truck rental during transition periods between residences\n" +
									"- Fewer logistics headaches"
							},
							{
								id: "students",
								label: "Students",
								title: "Students",
								description:
									"- Make moves between dorms and apartments easy\n" +
									"- Storage with free truck programs without relying on parents' vehicles or expensive rental companies"
							},
							{
								id: "military",
								label: "Military",
								title: "Military",
								description:
									"- Quickly move household goods into storage units with free truck access\n" +
									"- Efficiency process - one stop rental!\n" +
									"- [Great for deployment and relocation orders](https://www.storage.com/blog/how-self-storage-can-help-military-members-and-families/)"
							},
							{
								id: "seniors",
								label: "Seniors",
								title: "Seniors",
								description:
									"- Makes transitioning to smaller homes or retirement communities simple\n" +
									"- Reduce the physical strain of multiple trips\n" +
									"- Cost effective"
							},
							{
								id: "renovators",
								label: "Renovators",
								title: "Renovators",
								description:
									"- Move belongings to storage in one efficient trip\n" +
									"- Protects items from construction dust and damage"
							},
							{
								id: "business",
								label: "Small Business Owners",
								title: "Small Business Owners",
								description:
									"- Transport inventory, equipment, seasonal merchandise\n" +
									"- Move office furniture to storage\n" +
									"- Can reduce overhead costs on relocations"
							},
							{
								id: "renters",
								label: "Renters",
								title: "Renters",
								description:
									"- Helps bridge the transition by moving belongings to storage\n" +
									"- Reduces logistical stress"
							},
							{
								id: "estates",
								label: "Estates",
								title: "Estates",
								description:
									"- Efficiently sort and store items while making important decisions\n" +
									"- Use the truck to transport valuables and keepsakes safely"
							}
						]
					}
				}
			]
		},

		// ── 5. Inline CTA ───────────────────────────
		{
			title: "Truck Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Truck"
					}
				}
			]
		},

		// ── 6. Reviews ──────────────────────────────
		{
			title: "Truck Storage Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviews
				}
			]
		},

		// ── 7. FAQs ─────────────────────────────────
		{
			title: "Truck Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Storage Units with Free Truck Rentals FAQs",
						faqs
					}
				}
			]
		},

		// ── 8. Related Content ──────────────────────
		{
			title: "Truck Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Truck Storage",
						unitCards: relatedContentCards
					}
				}
			]
		},

		// ── 9. Link to Other PSPs ───────────────────
		{
			title: "Links to other PSP",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						background: "white",
						storageGridContent: {
							title: "More Ways to Store",
							image: illustrationSearch,
							storageTypes: storageCategories.truck
						}
					}
				}
			]
		},

		// ── 10. Nearby Cities ───────────────────────
		{
			title: "Truck Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						pageType: "PSP",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPTruckContent;
